import { globalEvents } from "../../common/src/utils";
import { initSheet } from "./pl_sheetHandler";
import { Sheet } from "./Sheet";
import { SheetCloseTypes, SheetEvents } from "./sheetEvents";

window.o_global.pali.sheetBuilder = Sheet;
window.o_global.pali.sheet = Sheet;

globalEvents.once("assets.events.documentReady", () =>
  window.o_util.event.delegate(document as never, "click", ".js_openInPaliSheet", (event) => {
    initSheet(event, Sheet);
  }),
);

export type { Sheet, SheetEvents, SheetCloseTypes };
